<template>
  <v-list>
    <draggable :value="items" :disabled="disabled" :handle="handle" @change="$emit('input', $event)">
      <div v-for="(item,index) in items" :key="index">
        <v-list-tile>
          <slot name="precontent" :item="item" :index="index"></slot>
          <v-list-tile-content>
            <slot name="content" :item="item" :index="index"></slot>
          </v-list-tile-content>
          <v-list-tile-action>
            <slot name="action" :item="item" :index="index"></slot>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider v-if="index + 1 < items.length" :key="index" pb-2></v-divider>
      </div>
    </draggable>
  </v-list>
</template>

<script>
import draggable from 'vuedraggable';
/**
 * @emits input
 */
export default {
  name: 'nx-sortable-list',
  props: {
    items: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
    handle: String,
  },
  components: {
    draggable,
  },
};
</script>
